import React, { useState } from 'react';
import { Button, Grid } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PropTypes from 'prop-types';
import FilterDialog from '../../../components/common/FilterButton/FilterDialog';

export const DepartmentFilter = ({ filters, onFiltersApply, onFiltersClear, filterProperties, initialFilters }) => {
    const [openFilterDialog, setOpenFilterDialog] = useState(false);

    return (
        <Grid container spacing={1} direction="row-reverse" justifyContent="flex-start" alignItems="center" mb={2}>
            <Grid item alignContent="flex-end" xs="auto">
                <Button
                    color="primary"
                    disabled={false}
                    onClick={() => setOpenFilterDialog(true)}
                    startIcon={<FilterAltIcon />}
                    size="medium"
                    variant={filters.length ? 'contained' : 'text'}
                >
                    Filter
                </Button>
                <FilterDialog
                    onApply={onFiltersApply}
                    onClear={onFiltersClear}
                    onClose={() => setOpenFilterDialog(false)}
                    open={openFilterDialog}
                    operators={[]}
                    properties={filterProperties}
                    initialFilters={initialFilters}
                    enableAddButton={false}
                />
            </Grid>
        </Grid>
    );
};

DepartmentFilter.defaultProps = {
    filters: [],
    view: 'all',
    actionItems: <></>,
};

DepartmentFilter.propTypes = {
    disabled: PropTypes.bool,
    filters: PropTypes.array,
    onFiltersApply: PropTypes.func,
    onFiltersClear: PropTypes.func,
    onQueryChange: PropTypes.func,
    onViewChange: PropTypes.func,
    query: PropTypes.string,
    view: PropTypes.string,
    actionItems: PropTypes.element,
};
